import { useTranslation } from 'react-i18next';

export default function PassengersSection({
    passengers,
    onPassengerChange,
    addPassenger,
    removePassenger,
    lang,
    personas
}) {

    const { t } = useTranslation();

    const canAddPassenger = passengers.length < personas;

    return (

        <>
            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Datos de los pasajeros")} ({personas})</h2>

            <table className="passengers-table t-align-center" style={{ marginLeft: "auto", marginRight: "auto" }}>

                <thead>
                    <tr className="u-align-center">
                        <th className="fontmontserrat"></th>
                        <th className="fontmontserrat">{t("Apellidos")}</th>
                        <th className="fontmontserrat">{t("Nombre")}</th>
                        <th className="fontmontserrat">{t("Fecha nacimiento")}</th>
                        <th className="fontmontserrat">{t("Pasaporte")}</th>
                        <th className="fontmontserrat">{t("Nacionalidad")}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>

                    {passengers.map((passenger, index) => (

                        <tr key={index}>

                            <td>
                                {index + 1}
                            </td>

                            <td>
                                <input
                                    type="text"
                                    value={passenger.lastName}
                                    onChange={(e) =>
                                        onPassengerChange(index, "lastName", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="text"
                                    value={passenger.firstName}
                                    onChange={(e) =>
                                        onPassengerChange(index, "firstName", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="date"
                                    value={passenger.birthDate}
                                    onChange={(e) =>
                                        onPassengerChange(index, "birthDate", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="text"
                                    value={passenger.passport}
                                    onChange={(e) =>
                                        onPassengerChange(index, "passport", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="text"
                                    value={passenger.nationality}
                                    onChange={(e) =>
                                        onPassengerChange(index, "nationality", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                {passengers.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => removePassenger(index)}
                                        className="u-active-palette-2-light-1 u-border-none u-btn-round u-button-style u-custom-color-5 u-hover-custom-color-7 u-radius-50 fontmontserrat"
                                        style={{ paddingLeft: "15px", paddingRight: "15px" }}
                                    >
                                        {t("Eliminar")}
                                    </button>
                                )}
                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

            {canAddPassenger && (
                <button
                    type="button"
                    onClick={addPassenger}
                    className="u-active-palette-2-light-1 u-border-none u-btn u-btn-round u-button-style u-custom-color-5 u-hover-custom-color-7 u-radius-50 u-btn-1 fontmontserrat"
                    style={{ marginLeft: "auto", marginRight: "auto" }}
                >
                    {t("Añadir pasajero")}
                </button>
            )}

        </>
    );
}
